import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

import {
  Breadcrumb as BaseBreadcrumb,
  BreadcrumbHomeIcon,
} from '@Calix-Commerce/design-system/components';
import { authenticationState } from 'state/atoms';
import { ORDER_MANAGER_PERMISSION } from 'utils/constants';

const Breadcrumb = () => {
  const history = useHistory();
  const location = useLocation();
  const { isAuthenticated, eCommerceAccess } = useRecoilValue(authenticationState);

  const hasOrderManagerAccess =
    isAuthenticated && eCommerceAccess.indexOf(ORDER_MANAGER_PERMISSION) !== -1;

  const showHomeIcon = location.pathname !== '/orders' && hasOrderManagerAccess;

  return (
    <BaseBreadcrumb>
      {showHomeIcon ? <BreadcrumbHomeIcon onClick={() => history.push('/')} /> : null}
    </BaseBreadcrumb>
  );
};

export { Breadcrumb };
